import { Expose } from "class-transformer";
import { CreateAnswerOptionDto } from "@/core/features/answer-option/create-answer-option.dto";

export class UpdateAnswerOptionDto extends CreateAnswerOptionDto {
  @Expose()
  id: string;
}
